export const AUTH_STATUS = {
  loading: 'loading',
  success: 'success',
  error: 'error'
};

export const OFFER_STATUS = {
  OK: 200,
  KO: 99
};

export const OFFER_COOKIE_TO_PAGE = {
  '5a': { routerName: 'step-2-uploaddoc-approved', step: 2 },
  '5c': { routerName: 'step-2-uploaddoc-study', step: 2 },
  '5d': { routerName: 'step-3-uploaddoc-summary', step: 3 },
  '6': { routerName: 'step-4-summary', step: 4 },
  'step-5-thanks': { routerName: 'step-5-thanks', step: 5 },
  'no-signed': { routerName: 'step-5-thanks', step: 0 },
  7: { routerName: 'redirect', step: 3 }
};

export const PAYMENT_COMPONENT_TYPE = {
  IBAN: 'IBAN',
  AMAZON_PAY: 'AmazonPay',
  STRIPE: 'Stripe'
};

export const DELIVERY_COMPONENT_TYPE = {
  ALD_LOCATION: 'RECOGIDA',
  HOME: 'DOMICILIO'
};

export const DATA_OPERATION = {
  CONTACT_TYPE: {
    ATTORNEY: 'APODERADO',
    CONTACT: 'CONTACTO'
  },
  CUSTOMER_TYPE: {
    PARTICULAR: 'PFISICA',
    COMPANY: 'PJURIDICA'
  },
  FLUX: {
    STRATOS: 'STRATOS',
    TESLA: 'TESLA',
    BBVA: 'BBVA'
  }
};

export const DOCUMENT_TYPES = {
  1: 'DNI',
  2: 'NIE'
};

/* ----------------------------
 * Fixed data of the UI module
 -----------------------------*/

export const PROVINCES = [
  { label: 'Álava', value: '01' },
  { label: 'Albacete', value: '02' },
  { label: 'Alicante', value: '03' },
  { label: 'Almería', value: '04' },
  { label: 'Ávila', value: '05' },
  { label: 'Badajoz', value: '06' },
  { label: 'Baleares', value: '07' },
  { label: 'Barcelona', value: '08' },
  { label: 'Burgos', value: '09' },
  { label: 'Cáceres', value: '10' },
  { label: 'Cádiz', value: '11' },
  { label: 'Castellón', value: '12' },
  { label: 'Ciudad Real', value: '13' },
  { label: 'Córdoba', value: '14' },
  { label: 'La Coruña', value: '15' },
  { label: 'Cuenca', value: '16' },
  { label: 'Girona ', value: '17' },
  { label: 'Granada ', value: '18' },
  { label: 'Guadalajara ', value: '19' },
  { label: 'Guipuzcoa ', value: '20' },
  { label: 'Huelva ', value: '21' },
  { label: 'Huesca ', value: '22' },
  { label: 'Jaén   ', value: '23' },
  { label: 'León  ', value: '24' },
  { label: 'Lleida ', value: '25' },
  { label: 'La Rioja  ', value: '26' },
  { label: 'Lugo   ', value: '27' },
  { label: 'Madrid ', value: '28' },
  { label: 'Málaga ', value: '29' },
  { label: 'Murcia ', value: '30' },
  { label: 'Navarra ', value: '31' },
  { label: 'Orense  ', value: '32' },
  { label: 'Asturias ', value: '33' },
  { label: 'Palencia ', value: '34' },
  { label: 'Las Palmas de G.C. ', value: '35' },
  { label: 'Pontevedra ', value: '36' },
  { label: 'Salamanca ', value: '37' },
  { label: 'Tenerife  ', value: '38' },
  { label: 'Cantabria ', value: '39' },
  { label: 'Segovia   ', value: '40' },
  { label: 'Sevilla   ', value: '41' },
  { label: 'Soria     ', value: '42' },
  { label: 'Tarragona ', value: '43' },
  { label: 'Teruel   ', value: '44' },
  { label: 'Toledo   ', value: '45' },
  { label: 'Valencia ', value: '46' },
  { label: 'Valladolid ', value: '47' },
  { label: 'Vizcaya  ', value: '48' },
  { label: 'Zamora   ', value: '49' },
  { label: 'Zaragoza ', value: '50' },
  { label: 'Ceuta  ', value: '51' },
  { label: 'Melilla ', value: '52' }
];

export const STEPS_OPTIONS = [
  {
    description: 'Te faltan',
    duration: 300
  },
  {
    description: 'Te faltan',
    duration: 240
  },
  {
    description: 'Te faltan',
    duration: 180
  },
  {
    description: 'Te faltan',
    duration: 120
  }
];

export const DIALOG_ERROR_CONFIG = {
  7: {
    icon: 'times-circle',
    iconColor: '#ED4B36',
    title: 'Credenciales incorrectas'
  },
  12: {
    icon: 'exclamation-circle',
    iconColor: '#f67f07',
    title: '¡Aviso importante!'
  },
  13: {
    icon: 'exclamation-circle',
    iconColor: '#f67f07',
    title: 'Operación existente',
    actions: [
      { type: 'secondary', text: 'Cancelar', action: 'goToPreviousOperation' },
      { type: 'primary', text: 'Continuar', action: 'cancelOtherOperations' }
    ]
  },
  15: {
    icon: 'exclamation-circle',
    iconColor: '#f67f07',
    title: 'Operación cancelada'
  },
  99: {
    icon: 'exclamation-circle',
    iconColor: '#f67f07',
    title: '¡Aviso importante!',
    description:
      'Error al ejecutar la operación. Si lo desea entre en contacto con nosotros. Gracias'
  },
  80: {
    icon: 'times-circle',
    iconColor: '#ED4B36',
    title: 'No hay stock'
  },
  81: {
    icon: 'times-circle',
    iconColor: '#ED4B36',
    title: 'IBAN no coincide'
  },
  90: {
    icon: 'times-circle',
    iconColor: '#ED4B36',
    title: 'Análisis de riesgo'
  }
};

/* --------------------------------
 * End fixed data of the UI module
 ---------------------------------*/
